<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nXPiUs/tc-custom/9781480478886.jpg?1733032714643" alt="This image is the cover for the book Legend of Mickey Free"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Legend of Mickey Free
      </h1>
      <p class="bookDescription body article font2">
        <b>Raised by the Apache, a young boy joins the US Army and becomes a legend of the Old West</b><br/><br/>Geronimo himself hears the baby crying in the burned-out campsite, surrounded by the bodies of the boy’s family. Even as an infant, Mickey Free is too strong to die. For thirteen years, this white child is raised as an Apache, learning the ways of the greatest warriors to ever mount a horse, and taking their cause as his own. When he turns thirteen, Mickey attempts the Run of the Arrow, a warrior’s ordeal that takes him across miles of desert wasteland with nothing but a mouthful of water to sustain him. Though he doesn’t know it when he starts his journey, Mickey will be running for years to come.<br/><br/>Betrayed by one whom he trusted most, this blue-eyed Apache is forced out of the tribe and into the uniform of the US Army. As a scout, he will become a legend, and a terror to those who once called him brother.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kerry Newcomb
      </h2>
      
      <p class="authorDescription body article">Kerry Newcomb was born in Milford, Connecticut, but had the good fortune to be raised in Texas. He has served in the Jesuit Volunteer Corps and taught at the St. Labre Mission School on the Northern Cheyenne Reservation in Montana, and holds a master&rsquo;s of fine arts degree in theater from Trinity University. Newcomb has written plays, film scripts, commercials, and liturgical dramas, and is the author of over thirty novels. He lives with his family in Fort Worth, Texas.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2dcb31fe